import React, { useMemo, useState } from "react";
import { DepotGroup, DepotIndex, Loc, FillPct } from "./types";
import { buildDepotIndex, nat } from "./utils";
import RandRow from "./RandRow";
import DepotPie from "./DepotPie";
import Minimap from "./Minimap";

type Filters = { r: string[]; k: string[]; p: string[] };

type Props = {
  group: DepotGroup;
  highlight: FillPct | null;
  filters: Filters;
  resolveNivel: (l: Loc) => FillPct;
};

const DepotSection: React.FC<Props> = ({
  group,
  highlight,
  filters,
  resolveNivel,
}) => {
  const [showSummary, setShowSummary] = useState(false);
  const { r, k, p } = filters;

  const filtered = useMemo(() => {
    if (!r.length && !k.length && !p.length) return group.data;
    return group.data.filter(
      (l) =>
        (r.length === 0 || r.includes(l.rand)) &&
        (k.length === 0 || k.includes(l.coloana)) &&
        (p.length === 0 || p.includes(l.polita)),
    );
  }, [group.data, r, k, p]);

  const index: DepotIndex = useMemo(
    () => buildDepotIndex(filtered),
    [filtered],
  );

  const rows = useMemo(() => {
    const entries: Array<[string, Map<string, Map<string, Loc[]>>]> = [];
    index.forEach((byCol, rand) => entries.push([rand, byCol]));
    return entries.sort(([r1], [r2]) => nat(r1, r2));
  }, [index]);

  return (
    <section className="wm-depot">
      <div className="wm-card wm-depot-card">
        <div className="wm-depot-header">
          <h2 className="wm-depot-title">
            Depozit <span className="wm-depot-badge">{group.cladire}</span>
          </h2>
          <button
            type="button"
            className="wm-btn wm-btn--ghost wm-depot-toggle"
            onClick={() => setShowSummary((v) => !v)}>
            {showSummary ? "Ascunde sumar" : "Arată sumar"}
          </button>
        </div>

        {showSummary && (
          <div className="wm-toolbar wm-toolbar--summary mb-6">
            <Minimap
              cladire={group.cladire}
              data={filtered}
              resolveNivel={resolveNivel}
            />
            <div className="wm-toolbar-spacer" />
            <DepotPie data={filtered} resolveNivel={resolveNivel} />
          </div>
        )}

        {rows.map(([rand, byCol]) => (
          <RandRow
            key={rand}
            rand={rand}
            byCol={byCol}
            highlight={highlight}
            resolveNivel={resolveNivel}
            depotId={group.cladire}
          />
        ))}
      </div>
    </section>
  );
};

export default React.memo(DepotSection);
